/**
 * SHA-256 hex helper + X-Expected-Devices hash for SKDM Phase 3b.
 * Format must stay identical between client (here) and server
 * (channel.service.ts:getChannelDeviceSlots): sorted slots
 * "userId.toLowerCase():deviceId" joined with "\n", SHA-256, hex.
 */

export async function sha256Hex(input: string): Promise<string> {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(input));
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export async function expectedDevicesHash(
  recipients: ReadonlyArray<{ userId?: string; deviceId: string }>,
): Promise<string | null> {
  const slots = recipients
    .filter((r): r is { userId: string; deviceId: string } => Boolean(r.userId))
    .map((r) => `${r.userId.toLowerCase()}:${r.deviceId}`)
    .sort();
  if (slots.length === 0) return null;
  return sha256Hex(slots.join("\n"));
}
